import AppRoutes from "./AppRoutes";
import { Icon } from "../../models/icons/Icon";
import {
  BriefcaseBusiness,
  MessageSquare,
  Scale,
  LayoutDashboard,
  ChartNoAxesCombined,
  Library,
  FileCode,
  Settings2,
  Users,
  BookText,
  CloudCog,
  LayoutTemplate,
  ShieldCheck,
  ListOrdered,
} from "lucide-react";
import { Permission } from "@/lib/permissions/Permission.enum";
import { PII_REDACTION_FEATURE_FLAG } from "@/hooks/usePiiFeatureEnabled";
import { CONSOLIDATION_PRIORITIZATION_FEATURE_FLAG } from "@/hooks/useConsolidationPrioritizationEnabled";
import {
  CustomIconProps,
  ToneOfVoiceIcon,
} from "@/pages/chat/components/ToneOfVoicePopover";

export type NavigationItemType = {
  name: string;
  path?: string;
  onClick?: () => void;
  icon: Icon | React.FC<CustomIconProps>;
  featureFlagName?: string;
  requiredPermissions?: { allOf?: Permission[]; oneOf?: Permission[] };
  subOf?: string;
};

export const navItems: NavigationItemType[] = [
  {
    name: "Dashboard",
    path: AppRoutes.dashboard,
    icon: LayoutDashboard,
  },
  {
    name: "Chat",
    path: AppRoutes.chat,
    icon: MessageSquare,
  },
  {
    name: "Kilder",
    path: AppRoutes.legislations,
    icon: Scale,
  },
  { name: "Workspaces", path: AppRoutes.workspaces, icon: BriefcaseBusiness },
];

export const adminNavItems: NavigationItemType[] = [
  {
    name: "Promptbibliotek",
    path: AppRoutes.promptLibrary + "?tab=accepted",
    icon: Library,
    requiredPermissions: {
      oneOf: [
        Permission.UpdatePromptsApproval,
        Permission.CreateTag,
        Permission.UpdateTag,
        Permission.DeleteTag,
      ],
    },
  },
  {
    name: "Insights",
    path: AppRoutes.insights,
    icon: ChartNoAxesCombined,
    requiredPermissions: { allOf: [Permission.ReadInsights] },
  },
  {
    name: "Tone of voice",
    path: AppRoutes.settingsToneOfVoice,
    icon: ToneOfVoiceIcon,
    requiredPermissions: {
      allOf: [
        Permission.CreateToneOfVoice,
        Permission.UpdateToneOfVoice,
        Permission.DeleteToneOfVoice,
      ],
    },
    subOf: "Indstillinger",
  },
  {
    name: "Brugerstyring",
    path: AppRoutes.settingsUserManagementUsers,
    icon: Users,
    requiredPermissions: { allOf: [Permission.ReadRoles] },
    subOf: "Indstillinger",
  },
  {
    name: "Entra sync",
    path: AppRoutes.settingsEntraDirectorySync,
    icon: CloudCog,
    requiredPermissions: { allOf: [Permission.UpdateTenantMetadata] },
    subOf: "Indstillinger",
  },
  {
    name: "Features",
    path: AppRoutes.settingsFeatures,
    icon: Settings2,
    requiredPermissions: { allOf: [Permission.ReadFeatureFlag] },
    subOf: "Indstillinger",
  },
  {
    name: "Metadata",
    path: AppRoutes.settingsMetadataTypes,
    icon: FileCode,
    requiredPermissions: { allOf: [Permission.UpdateTenantMetadata] },
    subOf: "Indstillinger",
  },
  {
    name: "Synonymer",
    path: AppRoutes.settingsSynonyms,
    icon: BookText,
    requiredPermissions: { allOf: [Permission.UpdateSynonymGroup] },
    subOf: "Indstillinger",
  },
  {
    name: "Widget-skabeloner",
    path: AppRoutes.settingsWidgetTemplates,
    icon: LayoutTemplate,
    requiredPermissions: { allOf: [Permission.ManageWidgetTemplates] },
    subOf: "Indstillinger",
  },
  {
    name: "Godkendte ord",
    path: AppRoutes.settingsPiiWhitelist,
    icon: ShieldCheck,
    featureFlagName: PII_REDACTION_FEATURE_FLAG,
    requiredPermissions: { allOf: [Permission.ManagePiiSettings] },
    subOf: "Indstillinger",
  },
  {
    name: "Konsolidering",
    path: AppRoutes.settingsConsolidationPriority,
    icon: ListOrdered,
    featureFlagName: CONSOLIDATION_PRIORITIZATION_FEATURE_FLAG,
    requiredPermissions: { allOf: [Permission.ManageConsolidationPriority] },
    subOf: "Indstillinger",
  },
];
